export default {
	subtitle: "",
	path: "webhooks_subscription_completed",
	paragraphs: [
		"This webhook is triggered when a subscription completes its full lifecycle — meaning all cycles have been processed and every related invoice has been successfully paid.",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"secret": "the value you received",
						"type": "subscription_completed",
						"subscription": {
							"id": "7de0dc6f-f514-4401-84f3-ff19183e6b92",
							"status": "completed",
							"subject_id": "76d5aea7-f532-47be-9cfb-b1f615c7bc84"
						},
					},
				},
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationSubscriptionCompleted.js